// Forms Clipboard

import ClipboardJS from 'clipboard';

$(document).ready(() => {

    new ClipboardJS('.clipboard-trigger');


});